"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Document = /** @class */ (function () {
    function Document() {
    }
    return Document;
}());
exports.default = Document;
//# sourceMappingURL=Document.js.map